<!--
 * @Author: guoyu
 * @Date: 2020-05-08 16:26:56
 * @LastEditors: your name
 * @LastEditTime: 2020-10-29 13:08:08
 * @Description: 通用的checkbox组件
 -->
<template>
  <div>
    <div v-if="$slots.group && !isRadio" @click="groupCheck">
      <slot name="group"></slot>
    </div>
    <div class="check-container">
      <div
        class="check-row"
        :class="{'is-one-col': col===1}"
        v-for="(row, index) in rowsOptions"
        :key="'row' + index"
        :style="rowStyle"
      >
        <div
          class="check-item"
          v-for="(item, cIndex) in row"
          :key="'r' + '-' + index + '-' + cIndex"
          :style="colStyle"
          @click="change(item, slotEmit)"
        >
          <slot
            :item="item"
            :checked="!!~checkedVal.indexOf(item[valKey])"
            :changeFn="change"
          ></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GeneralCheckbox',
  model: {
    event: 'change',
    prop: 'val'
  },
  props: {
    options: { type: Array, default: () => [] },
    val: { default: () => [] },
    type: { type: String, default: 'radio' },
    col: { type: Number, default: 2 }, // 列数
    slotEmit: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    rowStyle: { default: '' },
    colStyle: { default: '' },
    valKey: {
      type: String,
      default: 'value',
    }
  },
  computed: {
    checkedVal: {
      get() {
        if (!Array.isArray(this.val)) {
          return [this.val];
        }
        return this.val;
      }
    },
    isRadio() {
      return this.type === 'radio';
    },
    rows() {
      if (!this.col || this.col < 1) return 1;
      return Math.ceil(this.options.length / this.col);
    },
    rowsOptions() {
      let i = 0;
      let rowsArr = [];
      let col = 1;
      let cloneOptions = [].concat(this.options);
      while (cloneOptions.length) {
        if (!Array.isArray(rowsArr[i])) {
          rowsArr[i] = [];
        }
        rowsArr[i].push(cloneOptions.shift());
        if (col === this.col) {
          i++;
          col = 0;
        }
        col++;
      }
      return rowsArr;
    }
  },
  methods: {
    /**
     * @description:
     * @param {type}
     */

    change(item, slotEmit) {
      if (slotEmit || this.disabled) return;
      if (this.isRadio) {
        return this.radioChange(item);
      }
      let changeArray = [].concat(this.checkedVal);
      let index = changeArray.indexOf(item[this.valKey]);
      if (!~index) {
        changeArray.push(item[this.valKey]);
      } else {
        changeArray.splice(index, 1);
      }
      this.$emit('change', changeArray);
    },
    /**
     * @description: 单选时
     */
    radioChange(item) {
      if (this.checkedVal[0] !== item[this.valKey]) {
        this.$emit('change', item[this.valKey]);
        this.$emit('changeItem', item);
      }
    },
    /**
     * @description: 全选
     */
    groupCheck() {
      if (this.disabled) return;
      let changeArray = [].concat(this.checkedVal);
      if (changeArray.length === this.options.length) {
        changeArray = [];
      } else {
        changeArray = this.options.map(item => {
          return item[this.valKey];
        });
      }
      this.$emit('change', changeArray);
      this.$emit('changeItem', this.options);
    }
  }
};
</script>
<style lang="scss" scoped>
.check-container {
  position: relative;
  overflow: hidden;
}
.check-row {
  display: flex;
  justify-content: space-between;
}
.check-item {
  position: relative;
  .check-item{
    cursor: pointer;
  }
}
.is-one-col {
  justify-content: center;
}
</style>
